module.exports = __webpack_public_path__ + "static/media/all_welds_3.37aa79bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/all_welds_3.jpg
// module id = 1879
// module chunks = 0